import { render, staticRenderFns } from "./MainReceipt.vue?vue&type=template&id=b484517a&scoped=true&"
import script from "./MainReceipt.vue?vue&type=script&lang=ts&"
export * from "./MainReceipt.vue?vue&type=script&lang=ts&"
import style0 from "./MainReceipt.vue?vue&type=style&index=0&id=b484517a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b484517a",
  null
  
)

export default component.exports